<template>
  <div class="commonLiStyle">
    <top-component></top-component>
    <div class="titlePu">
      <div>参展出版社</div>
    </div>
    <div class="commonLiContainer">
      <div class="commontent">
        <div class="titleMap">这是文章标题</div>
        <div class="letterTitle">小标题</div>
        <div class="twodiv">
          田田网是拥有自主知识产权，集版权控制、纸电新书发布、图书馆采购与读者借阅、荐购服务、PDA实体采购为一体，专业面向图书馆的中文图书纸电同步平台。平台的内容仍由出版方提供，平台专注于为出版方、馆配商、图书馆搭建信息对接的桥梁，提供资源整合、信息推送、买卖交易等各种服务，意在建立一个图书馆和出版社之间的信息高速公路。
        </div>
        <img class="threediv" src="../../assets/images/gxg.png" alt="">
      </div>
    </div>
    <bottom-component></bottom-component>
  </div>
</template>

<script>
  import BottomComponent from '../Components/BottomComponent.vue'
  import TopComponent from '../Components/TopComponent.vue'
  export default {
    name: 'SchoolLibrary',
    data() {
      return {
      }
    },
    mounted() {
    },
    methods: {},
    components: {
      BottomComponent,
      TopComponent
    },
  }
</script>

<style scoped lang="scss">
  .commonLiStyle {
    width: 100%;
    background-color: #f9f9f9;
    overflow-x: hidden;
  }

  /* banner */
  .titlePu {
    height: 90px;
    width: 100%;
    background-image: url('../../assets/images/TopChild.png');
  }

  .titlePu>div {
    width: 1200px;
    height: 100%;
    margin: 0px auto;
    display: flex;
    align-items: center;
    color: rgba(51, 51, 51, 1);
    font-size: 24px;
    text-align: left;
    font-weight: 500;
    font-family: PingFang-SC-Bold;
  }

  /* 公共 */
  .commonLiContainer {
    width: 1180px;
    background-color: white;
    margin-left: calc(50% - 600px);
  }

  .commontent {
    width: 800px;
    margin: 0px auto;
    text-align: center;
  }

  /* title */
  .titleMap {
    color: rgba(0, 0, 0, 1);
    font-size: 40px;
    padding-top: 50px;
    text-align: left;
  }

  .letterTitle {
    color: rgba(51, 51, 51, 1);
    font-size: 16px;
    margin-top: 50px;
    text-align: left;
  }

  /* 1 */
  .twodiv {
    color: rgba(51, 51, 51, 1);
    font-size: 16px;
    margin-top: 10px;
    line-height: 25px;
    text-align: left;
  }

  /* 2 */
  .threediv {
    height: 320px;
    width: 700px;
    margin: 20px auto;
  }
</style>



// WEBPACK FOOTER //
// src/views/ChildPages/More-Product.vue